import { Chip } from "@mui/material";
import { useAppTheme } from "@/utils/theme";

type ChipStatusProps = {
  status: string;
  validationType?: string; // Optional: "First validation" or "Validation request"
};

const ChipStatus = ({ status, validationType }: ChipStatusProps) => {
  const theme = useAppTheme();

  const upperStatus = status.toUpperCase();
  const upperValidationType = validationType?.toUpperCase() || "";
  let displayLabel = status;
  let chipColors = theme.palette.chipStatus.default;
  const color = "#232B36"; // Text/Dark 2 from spec

  switch (upperStatus) {
    // Successful - Green (for both First validation and Validation request)
    case "SUCCESSFUL":
    case "POSITIVE": // Backend uses POSITIVE for successful
    case "NEGATIVE": // Backend uses NEGATIVE for successful (negative test result)
      chipColors = theme.palette.chipStatus.successful;
      displayLabel = "Successful";
      break;
    // Failed - Red for First validation, Orange for Validation request
    case "FAILED":
      if (
        upperValidationType.includes("FIRST_VALIDATION") ||
        upperValidationType.includes("FIRST VALIDATION")
      ) {
        chipColors = theme.palette.chipStatus.failedFirstValidation; // Red
      } else {
        chipColors = theme.palette.chipStatus.failed; // Orange
      }
      displayLabel = "Failed";
      break;
    // Missed - Red
    case "MISSED":
      chipColors = theme.palette.chipStatus.missed;
      displayLabel = "Missed";
      break;
    // Non-carriage - Orange
    case "NON_CARRIAGE":
    case "NON-CARRIAGE":
      chipColors = theme.palette.chipStatus.nonCarriage;
      displayLabel = "Non-carriage";
      break;
    // Pending - Should not be shown
    case "PENDING":
      return null;
    default:
      chipColors = theme.palette.chipStatus.default;
  }

  return (
    <Chip
      label={displayLabel}
      sx={{
        backgroundColor: chipColors.fill,
        borderColor: chipColors.border,
        borderWidth: 1,
        borderStyle: "solid",
        color,
        fontSize: "14px",
        height: "24px",
      }}
    />
  );
};

export default ChipStatus;
